import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable, throwError, timeout } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const timeoutInterceptor = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  // Устанавливаем таймаут 30 секунд для всех запросов
  return next(req).pipe(
    timeout(30000),
    catchError((error) => {
      if (error.name === 'TimeoutError') {
        return throwError(() => new Error('Превышено время ожидания запроса (30 секунд)'));
      }
      return throwError(() => error);
    })
  );
};
